// Copyright (c) 2021 Deere & Company

import DealerHierarchyLeadAccount from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-lead-account';
import t from 'tcomb';

const AuditFilteredLeadAccount = t.list(DealerHierarchyLeadAccount, 'AuditFilteredLeadAccount');

export const getDefaultState = () => new AuditFilteredLeadAccount([]);

export default AuditFilteredLeadAccount;



// WEBPACK FOOTER //
// ./src/tcsm/audits/state/audit-filtered-lead-account.js